import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import React, { Fragment } from 'react';
import { t } from 'i18next';
export function FormikRadioGroup({ name, formikProps, ...props }) {
    const { handleChange, values } = formikProps;
    return (_jsxs(RadioGroup, { value: values[name], name: name, onChange: handleChange, defaultValue: props.defaultValue, children: [props.label ? _jsx(FormLabel, { children: t(props.label) }) : null, props.options?.map((option, index) => (_jsx(Fragment, { children: _jsx(FormControlLabel, { sx: {
                        justifyContent: 'space-between',
                        marginLeft: 0,
                    }, control: _jsx(Radio, {}), label: t(option.label), value: option.value, labelPlacement: props.labelPlacement || 'start' }) }, index)))] }));
}
